// Babel helpers (cc_24): target language, foreign-text heuristic for the "Translate this chat?"
// nudge, and per-chat nudge dismissal (persisted like mobile).

export function targetLang(user) {
  return (user?.preferred_lang || navigator.language || "en").slice(0, 2).toLowerCase();
}

// Very common function words per language — enough to spot "this isn't my language" for Latin
// scripts. Non-Latin scripts are detected by Unicode range instead.
const STOP = {
  en: ["the", "and", "you", "that", "this", "with", "for", "are", "have", "not", "what", "your"],
  es: ["que", "los", "las", "para", "por", "con", "una", "está", "pero", "como", "muy", "hola"],
  fr: ["les", "des", "est", "pour", "avec", "une", "pas", "vous", "nous", "dans", "bonjour", "merci"],
  de: ["und", "der", "die", "das", "ist", "nicht", "ich", "mit", "für", "auf", "hallo", "danke"],
  pt: ["que", "não", "para", "com", "uma", "você", "está", "mas", "como", "muito", "olá", "obrigado"],
  it: ["che", "non", "per", "con", "una", "sono", "come", "questo", "ciao", "grazie", "molto", "anche"],
};
const NON_LATIN = /[\u0400-\u04FF\u0370-\u03FF\u0590-\u05FF\u0600-\u06FF\u0900-\u097F\u0E00-\u0E7F\u3040-\u30FF\u4E00-\u9FFF\uAC00-\uD7AF]/g;

export function looksForeign(text, target) {
  if (!text || text.length < 6) return false;
  const letters = text.replace(/[^\p{L}]/gu, "");
  if (!letters) return false;
  const nonLatin = (text.match(NON_LATIN) || []).length;
  if (nonLatin / letters.length > 0.3) return !["ru", "el", "he", "ar", "hi", "th", "ja", "zh", "ko"].includes(target) || !scriptMatches(target, text);
  const words = text.toLowerCase().split(/[^\p{L}']+/u).filter(Boolean);
  if (words.length < 3) return false;
  const hits = (lang) => words.filter((w) => STOP[lang]?.includes(w)).length;
  const own = hits(target);
  let best = 0;
  for (const lang of Object.keys(STOP)) if (lang !== target) best = Math.max(best, hits(lang));
  return best >= 2 && best > own;
}

function scriptMatches(target, text) {
  const map = { ru: /[\u0400-\u04FF]/, el: /[\u0370-\u03FF]/, he: /[\u0590-\u05FF]/, ar: /[\u0600-\u06FF]/, hi: /[\u0900-\u097F]/, th: /[\u0E00-\u0E7F]/, ja: /[\u3040-\u30FF\u4E00-\u9FFF]/, zh: /[\u4E00-\u9FFF]/, ko: /[\uAC00-\uD7AF]/ };
  return map[target] ? map[target].test(text) : false;
}

const NUDGE_KEY = "bloq_babel_nudge_dismissed";
function dismissed() {
  try { return JSON.parse(localStorage.getItem(NUDGE_KEY) || "[]"); } catch { return []; }
}
export const isNudgeDismissed = (chatId) => dismissed().includes(chatId);
export function dismissNudge(chatId) {
  const list = dismissed();
  if (!list.includes(chatId)) localStorage.setItem(NUDGE_KEY, JSON.stringify([...list, chatId].slice(-200)));
}

export const LANGS = [
  ["en", "English"], ["es", "Español"], ["fr", "Français"], ["de", "Deutsch"], ["pt", "Português"], ["it", "Italiano"],
  ["nl", "Nederlands"], ["pl", "Polski"], ["tr", "Türkçe"], ["ru", "Русский"], ["uk", "Українська"], ["ar", "العربية"],
  ["hi", "हिन्दी"], ["id", "Bahasa Indonesia"], ["vi", "Tiếng Việt"], ["th", "ไทย"], ["ja", "日本語"], ["ko", "한국어"], ["zh", "中文"],
];
